import React from 'react';

interface FlagIconProps {
  country: 'fr' | 'en' | 'es' | 'zh';
  className?: string;
}

const FlagIcon: React.FC<FlagIconProps> = ({
  country,
  className = 'w-5 h-5',
}) => {
  const flags = {
    fr: (
      <svg viewBox="0 0 640 480" className={className}>
        <g fillRule="evenodd" strokeWidth="1pt">
          <path fill="#fff" d="M0 0h640v480H0z" />
          <path fill="#00267f" d="M0 0h213.3v480H0z" />
          <path fill="#f31830" d="M426.7 0H640v480H426.7z" />
        </g>
      </svg>
    ),
    en: (
      <svg viewBox="0 0 640 480" className={className}>
        <g fillRule="evenodd">
          <path fill="#bd3d3a" d="M0 0h640v480H0z" />
          <path fill="#fff" d="M0 0h640v37.9H0z" />
          <path fill="#fff" d="M0 75.8h640v37.9H0z" />
          <path fill="#fff" d="M0 151.6h640v37.9H0z" />
          <path fill="#fff" d="M0 227.4h640v37.9H0z" />
          <path fill="#fff" d="M0 303.2h640v37.9H0z" />
          <path fill="#fff" d="M0 379h640v37.9H0z" />
          <path fill="#fff" d="M0 454.8h640v37.9H0z" />
          <path fill="#192f5d" d="M0 0h256v204H0z" />
          <g fill="#fff">
            <circle cx="32" cy="18" r="4" />
            <circle cx="64" cy="18" r="4" />
            <circle cx="96" cy="18" r="4" />
            <circle cx="128" cy="18" r="4" />
            <circle cx="160" cy="18" r="4" />
            <circle cx="192" cy="18" r="4" />
            <circle cx="224" cy="18" r="4" />
            <circle cx="48" cy="34" r="4" />
            <circle cx="80" cy="34" r="4" />
            <circle cx="112" cy="34" r="4" />
            <circle cx="144" cy="34" r="4" />
            <circle cx="176" cy="34" r="4" />
            <circle cx="208" cy="34" r="4" />
            <circle cx="32" cy="50" r="4" />
            <circle cx="64" cy="50" r="4" />
            <circle cx="96" cy="50" r="4" />
            <circle cx="128" cy="50" r="4" />
            <circle cx="160" cy="50" r="4" />
            <circle cx="192" cy="50" r="4" />
            <circle cx="224" cy="50" r="4" />
            <circle cx="48" cy="66" r="4" />
            <circle cx="80" cy="66" r="4" />
            <circle cx="112" cy="66" r="4" />
            <circle cx="144" cy="66" r="4" />
            <circle cx="176" cy="66" r="4" />
            <circle cx="208" cy="66" r="4" />
            <circle cx="32" cy="82" r="4" />
            <circle cx="64" cy="82" r="4" />
            <circle cx="96" cy="82" r="4" />
            <circle cx="128" cy="82" r="4" />
            <circle cx="160" cy="82" r="4" />
            <circle cx="192" cy="82" r="4" />
            <circle cx="224" cy="82" r="4" />
            <circle cx="48" cy="98" r="4" />
            <circle cx="80" cy="98" r="4" />
            <circle cx="112" cy="98" r="4" />
            <circle cx="144" cy="98" r="4" />
            <circle cx="176" cy="98" r="4" />
            <circle cx="208" cy="98" r="4" />
            <circle cx="32" cy="114" r="4" />
            <circle cx="64" cy="114" r="4" />
            <circle cx="96" cy="114" r="4" />
            <circle cx="128" cy="114" r="4" />
            <circle cx="160" cy="114" r="4" />
            <circle cx="192" cy="114" r="4" />
            <circle cx="224" cy="114" r="4" />
            <circle cx="48" cy="130" r="4" />
            <circle cx="80" cy="130" r="4" />
            <circle cx="112" cy="130" r="4" />
            <circle cx="144" cy="130" r="4" />
            <circle cx="176" cy="130" r="4" />
            <circle cx="208" cy="130" r="4" />
            <circle cx="32" cy="146" r="4" />
            <circle cx="64" cy="146" r="4" />
            <circle cx="96" cy="146" r="4" />
            <circle cx="128" cy="146" r="4" />
            <circle cx="160" cy="146" r="4" />
            <circle cx="192" cy="146" r="4" />
            <circle cx="224" cy="146" r="4" />
            <circle cx="48" cy="162" r="4" />
            <circle cx="80" cy="162" r="4" />
            <circle cx="112" cy="162" r="4" />
            <circle cx="144" cy="162" r="4" />
            <circle cx="176" cy="162" r="4" />
            <circle cx="208" cy="162" r="4" />
            <circle cx="32" cy="178" r="4" />
            <circle cx="64" cy="178" r="4" />
            <circle cx="96" cy="178" r="4" />
            <circle cx="128" cy="178" r="4" />
            <circle cx="160" cy="178" r="4" />
            <circle cx="192" cy="178" r="4" />
            <circle cx="224" cy="178" r="4" />
            <circle cx="48" cy="194" r="4" />
            <circle cx="80" cy="194" r="4" />
            <circle cx="112" cy="194" r="4" />
            <circle cx="144" cy="194" r="4" />
            <circle cx="176" cy="194" r="4" />
            <circle cx="208" cy="194" r="4" />
          </g>
        </g>
      </svg>
    ),
    es: (
      <svg viewBox="0 0 640 480" className={className}>
        <g fillRule="evenodd" strokeWidth="1pt">
          <path fill="#aa151b" d="M0 0h640v480H0z" />
          <path fill="#f1bf00" d="M0 120h640v240H0z" />
        </g>
      </svg>
    ),
    zh: (
      <svg viewBox="0 0 640 480" className={className}>
        <g fillRule="evenodd" strokeWidth="1pt">
          <path fill="#de2910" d="M0 0h640v480H0z" />
          <g fill="#ffde00">
            <g id="d">
              <g id="c">
                <g id="b">
                  <g id="a" fill="#ffde00">
                    <path d="M320 100l-4 12h-12l10 7-4 12 10-7 10 7-4-12 10-7h-12z" />
                    <path d="M280 180l-8 24h-24l20 14-8 24 20-14 20 14-8-24 20-14h-24z" />
                    <path d="M360 180l-8 24h-24l20 14-8 24 20-14 20 14-8-24 20-14h-24z" />
                    <path d="M320 260l-4 12h-12l10 7-4 12 10-7 10 7-4-12 10-7h-12z" />
                  </g>
                  <use href="#a" transform="rotate(15 320 240)" />
                  <use href="#a" transform="rotate(30 320 240)" />
                  <use href="#a" transform="rotate(45 320 240)" />
                </g>
                <use href="#b" transform="rotate(60 320 240)" />
              </g>
              <use href="#c" transform="rotate(120 320 240)" />
            </g>
            <use href="#d" transform="rotate(240 320 240)" />
          </g>
        </g>
      </svg>
    ),
  };

  return flags[country];
};

export default FlagIcon;
